import { CopySimple } from '@phosphor-icons/react';
import React, { useState } from 'react';
import CopyToClipboard from 'react-copy-to-clipboard';
import { onShareWhatsapp } from '../../../utils/commonUtils';

const ShareEvent = (props) => {
  const { link, showLink } = props;

  const [copiedEventLink, setCopiedEventLink] = useState(false);

  const getShareText = () => encodeURI(`Hey! Checkout this event listed in Take My Tickets! ${link}`);

  const handleCopyTicket = () => {
    if (navigator.clipboard) {
      navigator.clipboard.writeText(link);
      setCopiedEventLink(true);
      setTimeout(() => setCopiedEventLink(false), 2000);
    }
  };

  return (
    <div className="flex flex-col gap-4">
    <h1 className="heading-16 md:text-2xl">
      Share this event with friends
    </h1>
    {showLink && (
      <div className='label-14 cursor-pointer p-4 border-[1px] border-grey-30 rounded-md' onClick={handleCopyTicket}>{link}</div>
    )}
    <div className="flex gap-4 items-center">
      <img src="assets/images/wp.svg" className="w-10 h-10 cursor-pointer" onClick={() => onShareWhatsapp(null, getShareText())} />
      <a href={`https://www.facebook.com/sharer/sharer.php?description=${getShareText()}`} target="_blank" rel="noreferrer"><img src="assets/images/fb.svg" /></a>
      <a href={`https://twitter.com/intent/tweet?text=${getShareText()}`} target="_blank" rel="noreferrer"><img src="assets/images/x.svg" /></a>
      <div className="flex gap-2 items-center px-3 py-4 rounded-lg bg-light-white border border-[#E7E7E7] border-dashed cursor-pointer" onClick={handleCopyTicket}>
      <p className="label-14">{copiedEventLink ? 'Copied!' : 'Copy Link'}</p>
        <CopyToClipboard onCopy={handleCopyTicket}>
          <CopySimple
            size={24}
            color={copiedEventLink ? "grey" : "black"}
          />
        </CopyToClipboard>
      </div>
    </div>
  </div>
  );
};

export default ShareEvent;
